import translationInstance from '../utils/translations';
const t = translationInstance.t.bind(translationInstance);

const PartialWood =
{
    _id: '5e6c9e6d-09ec-4c02-9538-section',
    actions: [],
    controlType: 'section',
    name: t('virtenzo.configurator.section_wood'),
    headlineText: t('virtenzo.configurator.section_wood'),
    classes: ['virtenzo-panel-section'],
    subOptions: [
      {
        _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a6',
        actions: [],
        controlType: 'sectionHeadline',
        name: t('virtenzo.configurator.section_wood'),
        classes: ['virtenzo-panel-section-headline', 'section-root-headline', 'big-headline'],
        href: '',
      },
      {
        _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a7',
        actions: [],
        controlType: 'sectionHeadline',
        name: t('virtenzo.configurator.beech'),
        classes: ['virtenzo-panel-section-headline'],
        href: '',
      },
      {
        _id: 'beech-section',
        actions: [],
        controlType: 'section',
        name: t('virtenzo.configurator.beech'),
        classes: ['virtenzo-panel-section', 'beech-section', 'wood-section'],
        subOptions: [
          {
            _id: '8004c9f8-1534-4601-808b-bae614e372f2',
            actions: [
              {
                _id: '9a87ee91-aa42-4d8b-a61b-b3db44d4ed46',
                functionName: 'setMaterialByObjectPrefixMaterialName',
                prefix: 'wood',
                materialName: 'Natural Beech',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD',
                value: 'BEECH',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD_LABEL',
                value: 'Natural Beech',
              },
            ],
            controlType: 'imageButton',
            imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/natural_beech_diffuse.jpg',
            name: 'Natural Beech',
            text: 'Natural Beech',
            classes: ['virtenzo-panel-button'],
            href: '',
            groups: 'Wood',
          },
          {
            _id: '1c2fdfe9-713b-4d1f-add6-e3d0d8cdb541',
            actions: [
              {
                _id: '63da66a7-3008-48b9-9c54-eb467ca79ad4',
                functionName: 'setMaterialByObjectPrefixMaterialName',
                prefix: 'wood',
                materialName: 'Beech Nero MAT',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD',
                value: 'BEECH',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD_LABEL',
                value: 'Beech Nero MAT',
              },
            ],
            controlType: 'imageButton',
            imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/beech_nero_mat_diffuse.jpg',
            name: 'Beech Nero MAT',
            text: 'Beech Nero MAT',
            classes: ['virtenzo-panel-button'],
            href: '',
            groups: 'Wood',
          },
          {
            _id: '50d59d55-3ce4-46fc-aac0-b3d7107e86a5',
            actions: [
              {
                _id: '9dc9f728-a6c6-420e-b6b2-9cb5b20d2bcc',
                functionName: 'setMaterialByObjectPrefixMaterialName',
                prefix: 'wood',
                materialName: 'Beech Taupe',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD',
                value: 'BEECH',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD_LABEL',
                value: 'Beech Taupe',
              },
            ],
            controlType: 'imageButton',
            imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/beech_taupe_diffuse.jpg',
            name: 'Beech Taupe',
            text: 'Beech Taupe',
            classes: ['virtenzo-panel-button'],
            href: '',
            groups: 'Wood',
          },
          {
            _id: 'd04904ac-fa79-47b6-9fe7-50a8020fbe0f',
            actions: [
              {
                _id: 'bd718dc3-7f52-4479-a4f0-bc9e27b9496b',
                functionName: 'setMaterialByObjectPrefixMaterialName',
                prefix: 'wood',
                materialName: 'Beech Light Walnut',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD',
                value: 'BEECH',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD_LABEL',
                value: 'Beech Light Walnut',
              },
            ],
            controlType: 'imageButton',
            imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/beech_light_walnut_diffuse.jpg',
            name: 'Beech Light Walnut',
            text: 'Beech Light Walnut',
            classes: ['virtenzo-panel-button'],
            href: '',
            groups: 'Wood',
          },
          {
            _id: 'd04904ac-fa79-47b6-9fe7-50a8020fbe0f',
            actions: [
              {
                _id: 'bd718dc3-7f52-4479-a4f0-bc9e27b9496b',
                functionName: 'setMaterialByObjectPrefixMaterialName',
                prefix: 'wood',
                materialName: 'Legno Tabac',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD',
                value: 'BEECH',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD_LABEL',
                value: 'Legno Tabac',
              },
            ],
            controlType: 'imageButton',
            imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/legno_tabac_diffuse.jpg',
            name: 'Legno Tabac',
            text: 'Legno Tabac',
            classes: ['virtenzo-panel-button'],
            href: '',
            groups: 'Wood',
          },
        ],
      },
      {
        _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a7',
        actions: [],
        controlType: 'sectionHeadline',
        name: t('virtenzo.configurator.oak'),
        classes: ['virtenzo-panel-section-headline'],
        href: '',
      },
      {
        _id: 'oak-section',
        actions: [],
        controlType: 'section',
        name: t('virtenzo.configurator.oak'),
        classes: ['virtenzo-panel-section', 'oak-section', 'wood-section'],
        subOptions: [
          {
            _id: 'e2073f96-45c1-4b1a-a96b-e6e994ef1e29',
            actions: [
              {
                _id: 'e8a90ca1-7c16-486b-b2f8-8281dbc5714d',
                functionName: 'setMaterialByObjectPrefixMaterialName',
                prefix: 'wood',
                materialName: 'Oak Oil Natural',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD',
                value: 'OAK',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD_LABEL',
                value: 'Oak Oil Natural',
              },
            ],
            controlType: 'imageButton',
            imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/oak_oil_natural_diffuse.jpg',
            name: 'Oak Oil Natural',
            text: 'Oak Oil Natural',
            classes: ['virtenzo-panel-button'],
            href: '',
            groups: 'Wood',
          },
          {
            _id: '3d58982d-c02f-47a5-8b03-7ced81ad5992',
            actions: [
              {
                _id: '0d71a490-2c73-4bff-9337-8f3973fd3e85',
                functionName: 'setMaterialByObjectPrefixMaterialName',
                prefix: 'wood',
                materialName: 'Oak Oil Bianco',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD',
                value: 'OAK',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD_LABEL',
                value: 'Oak Oil Bianco',
              },
            ],
            controlType: 'imageButton',
            imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/oak_oil_bianco_diffuse.jpg',
            name: 'Oak Oil Bianco',
            text: 'Oak Oil Bianco',
            classes: ['virtenzo-panel-button'],
            href: '',
            groups: 'Wood',
          },
          {
            _id: 'dcfd0cd4-40c7-4920-92bb-53e0c384e4c5',
            actions: [
              {
                _id: '8e449b77-aa9a-493f-9d8e-05be0588ec32',
                functionName: 'setMaterialByObjectPrefixMaterialName',
                prefix: 'wood',
                materialName: 'Waxed Wild Oak',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD',
                value: 'OAK',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD_LABEL',
                value: 'Waxed Wild Oak',
              },
            ],
            controlType: 'imageButton',
            imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/waxed_wild_oak_diffuse.jpg',
            name: 'Waxed Wild Oak',
            text: 'Waxed Wild Oak',
            classes: ['virtenzo-panel-button'],
            href: '',
            groups: 'Wood',
          },
          {
            _id: '07d563dc-2c06-4ea6-ad24-91d931958859',
            actions: [
              {
                _id: '27dafbe1-2b90-47bd-9017-3cc1a1a76b2c',
                functionName: 'setMaterialByObjectPrefixMaterialName',
                prefix: 'wood',
                materialName: 'Oak Pure Heban',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD',
                value: 'OAK',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD_LABEL',
                value: 'Oak Pure Heban',
              },
            ],
            controlType: 'imageButton',
            imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/oak_pure_heban_diffuse.jpg',
            name: 'Oak Pure Heban',
            text: 'Oak Pure Heban',
            classes: ['virtenzo-panel-button'],
            href: '',
            groups: 'Wood',
          },
          {
            _id: 'e2073f96-45c1-4b1a-a96b-e6e994ef1e29',
            actions: [
              {
                _id: 'e8a90ca1-7c16-486b-b2f8-8281dbc5714d',
                functionName: 'setMaterialByObjectPrefixMaterialName',
                prefix: 'wood',
                materialName: 'Oak Carbon',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD',
                value: 'OAK',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD_LABEL',
                value: 'Oak Carbon',
              },
            ],
            controlType: 'imageButton',
            imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/oak_carbon_diffuse.jpg',
            name: 'Oak Carbon',
            text: 'Oak Carbon',
            classes: ['virtenzo-panel-button'],
            href: '',
            groups: 'Wood',
          },
        ],
      },
      {
        _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a7',
        actions: [],
        controlType: 'sectionHeadline',
        name: t('virtenzo.configurator.american_walnut'),
        classes: ['virtenzo-panel-section-headline'],
        href: '',
      },
      {
        _id: 'american-walnut-section',
        actions: [],
        controlType: 'section',
        name: t('virtenzo.configurator.american_walnut'),
        classes: ['virtenzo-panel-section', 'american-walnut-section', 'wood-section'],
        subOptions: [
          {
            _id: '07f872f7-9b87-4629-9930-605733af0628',
            actions: [
              {
                _id: '2832a7e0-2194-49cf-be79-dae7749b6eb3',
                functionName: 'setMaterialByObjectPrefixMaterialName',
                prefix: 'wood',
                materialName: 'American Walnut Natural Oil',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD',
                value: 'AMERICAN_WALNUT',
              },
              {
                functionName: 'setSystemVariable',
                name: 'WOOD_LABEL',
                value: 'American Walnut Natural Oil',
              },
            ],
            controlType: 'imageButton',
            imageSrc:
              'https://static.virtenzo.com/clients/estetica-home/textures/american_walnut_natural_oil_diffuse.jpg',
            name: 'American Walnut Natural Oil',
            text: 'American Walnut Natural Oil',
            classes: ['virtenzo-panel-button', 'virtenzo-fb40'],
            href: '',
            groups: 'Wood',
          },
        ],
      },
    ],
  }


export default PartialWood;